import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faMapMarkerAlt, faPhone } from '@fortawesome/free-solid-svg-icons';
import ReactTooltip from 'react-tooltip';
import './index.scss';
import { capitalizeFirstLetter } from "../../../../utils/common";
const LocationInfo = ({ info }) => {
    return (
        <>
            <div className="location-info">
                <h2 data-tip={info?.name && capitalizeFirstLetter(info?.name)} >{info?.name && capitalizeFirstLetter(info?.name)}</h2>
                <p>
                    <span className="d-inline-flex align-items-center justify-content-center">
                        <FontAwesomeIcon icon={faMapMarkerAlt} />
                    </span>
                    <label data-tip={info?.address} >{info.address}</label>
                </p>
                <p>
                    <span className="d-inline-flex align-items-center justify-content-center">
                        <FontAwesomeIcon icon={faEnvelope} />
                    </span>
                    <a href={`mailto:${info.email}`} data-tip={info?.email} >{info.email}</a>
                </p>
                <p className="tel-link">
                    <span className="d-inline-flex align-items-center justify-content-center">
                        <FontAwesomeIcon icon={faPhone} />
                    </span>
                    <a href={`tel:${info.phone}`}>{info.phone}</a>
                </p>
            </div>
            <ReactTooltip />
        </>
    )
};
export default LocationInfo;